module.exports = __webpack_public_path__ + "img/LaMilla.5d521eb6.webp";